"use client";

import { ReactNode, useMemo } from "react";
import { cn } from "~/lib/utils";
import { usePricesSearchParams } from "~/app/tickets/[eventId]/_components/Filter/hooks";
import { Filter as FilterIcon, X } from "lucide-react";
import { useTranslations } from "~/hooks/useTranslations";
import { Button, buttonVariants } from "~/components/ui/button";

interface ITriggerButton {
  onOpen: () => void;
}

export function TriggerButton({ onOpen }: Readonly<ITriggerButton>): ReactNode {
  const t = useTranslations();
  const [searchParams, _, clearSearchParams] = usePricesSearchParams();

  const filterCount = useMemo(() => {
    return Object.values(searchParams).filter((value) => value !== null).length;
  }, [searchParams]);

  const filtersSet = useMemo(() => {
    return (
      (searchParams.min !== null && searchParams.max !== null) ||
      searchParams.category !== null
    );
  }, [searchParams.min, searchParams.max, searchParams.category]);

  return (
    <div
      onClick={onOpen}
      className={cn(
        "group relative cursor-pointer",
        buttonVariants({ variant: "dark" }),
        filtersSet && "bg-[#0958D9] hover:bg-[#0958D9]/80",
      )}
      aria-label="Toggle closed tasks"
    >
      <span className="flex items-center gap-2">
        <FilterIcon />
        <span>
          {t.filter} {filterCount > 0 && `(${filterCount})`}
        </span>
      </span>
      {filtersSet && (
        <Button
          onClick={(e) => {
            e.stopPropagation();
            clearSearchParams();
          }}
          variant="ghost"
          className="absolute right-0 top-0 aspect-square h-[100%] !bg-[#0958D9] p-0 text-white opacity-0 transition-opacity hover:text-white/80 group-hover:opacity-100"
        >
          <span>
            <X />
          </span>
        </Button>
      )}
    </div>
  );
}
